import dayjs from 'dayjs';

const isFormat = (format: string, date: string, locale?: string): boolean =>
  dayjs(date, format, locale || 'en', true).isValid();

export { isFormat };
